import { useQuery } from '@tanstack/react-query';

import adminAxios from '@/apis/admin-api/axios';

type GetTokenStatusResponse = {
  reservableTokens: number;
  reservedTokens: number;
  tokensLeftInPackages: number;
};

const getTokenStatus = async (organizationId: string) => {
  const { data } = await adminAxios.post<GetTokenStatusResponse>('/api/Token/GetTokenStatus', { organizationId });
  return data;
};

export const useGetTokenStatus = (organizationId?: string) => {
  return useQuery({
    queryKey: ['token-status', organizationId],
    queryFn: () => getTokenStatus(organizationId!),
    enabled: !!organizationId,
    refetchOnWindowFocus: false,
  });
};
